import { render, staticRenderFns } from "./auth-password.vue?vue&type=template&id=3b94e7b5&scoped=true&lang=pug"
import script from "./auth-password.js?vue&type=script&lang=js&external"
export * from "./auth-password.js?vue&type=script&lang=js&external"
import style0 from "./auth-password.vue?vue&type=style&index=0&id=3b94e7b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b94e7b5",
  null
  
)

export default component.exports